import { useEffect } from 'react';
import {
  BookingFormType,
  FormBookingType,
} from '../../../redux/types/bookingTypes';
import {
  ButtonType,
  InputModeType,
  InputType,
} from '../../../utils/@globalTypes';
import Input from '../../Input';
import BookingSectionTitle from '../BookingSectionTitle';
import { TELEGRAM_REQ } from '../../../utils/constants';
import styles from './BookingContactBlock.module.scss';
import { FormikProps, useFormikContext } from 'formik';
import Button from '../../Button';
import {
  TelegramIcon,
  TelephoneIcon2,
  ViberIcon,
  WhatsupIcon,
} from '../../../assets/icons';
import {
  callPhone,
  callTelegram,
  callViber,
  callWhatsApp,
} from '../../../utils/functions';
import PhoneNumberInput from '../../PhoneNumberInput';

type ContactblockProps = {
  windowType?: BookingFormType;
  formik: FormikProps<FormBookingType>;
};

const BookingContactBlock = ({ windowType, formik }: ContactblockProps) => {
  const {
    handleChange,
    values,
    errors,
    initialValues,
    validateField,
    setFieldTouched,
    touched,
  } = formik;
  const { setFieldValue } = useFormikContext();

  useEffect(() => {
    if (touched.email) {
      validateField('email');
    }
  }, [touched, values]);

  useEffect(() => {
    if (touched.telegram && values.telegram) {
      validateField('telegram');
    }
  }, [touched, values]);

  useEffect(() => {
    if (touched.phone) {
      validateField('phone');
    }
  }, [touched, values]);

  const initialPhoneNumber = values.phone;

  return (
    <div className={styles.wrap} id="wrap">
      <BookingSectionTitle title="Контакты" />
      <div className={styles.container}>
        <div>
          <Input
            id="email"
            value={values.email}
            title={
              windowType === BookingFormType.view
                ? 'Электронная почта'
                : 'Электронная почта*'
            }
            name="email"
            placeholder="Введите электронную почту"
            containerClassName={styles.inputСontainer}
            className={styles.booking}
            type={InputType.EMAIL}
            inputMode={InputModeType.EMAIL}
            errText={errors.email}
            onChange={handleChange('email')}
            onBlur={() => setFieldTouched('email')}
            banSymbols={/\s/g}
            disabled={windowType === BookingFormType.view ? true : false}
            isBooking={true}
            autoComplete="email"
          />
        </div>

        <PhoneNumberInput
          id="phone"
          name="phone"
          value={values.phone}
          title={
            windowType === BookingFormType.view
              ? 'Контактный телефон'
              : 'Контактный телефон*'
          }
          placeholder="Введите номер"
          disabled={windowType === BookingFormType.view ? true : false}
          errText={errors.phone}
          onChange={(val) => {
            setFieldValue('phone', val);
          }}
          onBlur={() => setFieldTouched('phone')}
          isBooking={true}
        />
        <div className={styles.telegram}>
          <Input
            id="telegram"
            value={values.telegram}
            title="Telegram"
            name="telegram"
            placeholder={
              windowType === BookingFormType.view ? '-' : '@nickname'
            }
            containerClassName={styles.inputСontainer}
            className={styles.booking}
            type={InputType.TEXT}
            inputMode={InputModeType.TEXT}
            errText={errors.telegram}
            onChange={handleChange('telegram')}
            onBlur={() => setFieldTouched('telegram')}
            banSymbols={/\s/g}
            requirementsText={
              windowType === BookingFormType.view ? undefined : TELEGRAM_REQ
            }
            disabled={windowType === BookingFormType.view ? true : false}
            isBooking={true}
          />
        </div>
        {windowType !== BookingFormType.new && (
          <div className={styles.btnLine}>
            <div className={styles.phone}>
              <Button
                type={ButtonType.SMALL}
                title={<TelephoneIcon2 fill="#FFFFFF" />}
                onClick={() => callPhone(initialPhoneNumber)}
                isStrokeIcon
                wrapperClassName="social"
                disabled={!!errors.phone || !initialPhoneNumber}
              />
            </div>
            <div className={styles.viber}>
              <Button
                type={ButtonType.SMALL}
                title={<ViberIcon />}
                onClick={() => callViber(initialPhoneNumber)}
                wrapperClassName="social"
                disabled={!!errors.phone || !initialPhoneNumber}
              />
            </div>
            <div className={styles.wup}>
              <Button
                type={ButtonType.SMALL}
                title={<WhatsupIcon />}
                onClick={() => callWhatsApp(initialPhoneNumber)}
                isStrokeIcon
                wrapperClassName="social"
                disabled={!!errors.phone || !initialPhoneNumber}
              />
            </div>
          </div>
        )}
        {windowType !== BookingFormType.new && (
          <div className={styles.telegramBtn}>
            <Button
              type={ButtonType.SMALL}
              title={<TelegramIcon fill="#FFFFFF" width="28" height="26" />}
              onClick={() => callTelegram(initialValues.telegram)}
              isStrokeIcon
              disabled={!initialValues.telegram}
              wrapperClassName="telegram"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default BookingContactBlock;
